import { useState, useCallback } from 'react';
import SuperpartnerService from '../services/SuperpartnerService/SuperpartnerService'; // Creeremo questo servizio tra poco
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useSuperpartner = () => {
    // Aggiungiamo stati per il loading e per le modali, come in useAgenzie
    const [loadingState, setLoadingState] = useState({
        isLoadingSuperpartner: false,
        isSuperpartnerCreating: false,
        isSuperpartnerDeleting: false,
        isSuperpartnerUpdating: false,
    });

    const [modalState, setModalState] = useState({
        showModalCreateSuperpartner: false,
        showModalUpdateSuperpartner: false,
        showModalDeleteSuperpartner: false,
        showModalInfoSuperpartner: false,
    });

    // La tua funzione originale, leggermente adattata
    const getAllSuperpartner = async () => {
        setLoadingState(prev => ({ ...prev, isLoadingSuperpartner: true }));
        try {
            let response = await SuperpartnerService.getAllSuperpartner();
            if (response.ok) {
                const superpartner = await response.json();
                return superpartner;
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingSuperpartner: false }));
        }
    };
    
    // --- NUOVE FUNZIONI (Simili a quelle di useAgenzie.js) ---

    const getSuperpartnerByParams = async (params) => {
        setLoadingState(prev => ({ ...prev, isLoadingSuperpartner: true }));
        try {
            const response = await SuperpartnerService.getSuperpartnerByParams(params);
            // console.log(response);
            // alert(response);
            const res = await response.json();
            const totalRecord = response.headers.get('X-Total-Record');
            return { data: res, count: totalRecord };
        } catch (err) {
            handleError(err);
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingSuperpartner: false }));
        }
    };

    const createSuperpartner = async (data) => {
        setLoadingState(prev => ({ ...prev, isSuperpartnerCreating: true }));
        try {
            const res = await SuperpartnerService.createSuperpartner(data);
            alertService.success("Superpartner creato con successo!", { autoClose: true });
            return res;
        } catch (error) {
            handleError(error);
            throw error;
        } finally {
            setLoadingState(prev => ({ ...prev, isSuperpartnerCreating: false }));
        }
    };

    const updateSuperpartner = async (data) => {
        setLoadingState(prev => ({ ...prev, isSuperpartnerUpdating: true }));
        try {
            const res = await SuperpartnerService.updateSuperpartner(data);
            alertService.success("Superpartner aggiornato con successo!", { autoClose: true });
            return res;
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isSuperpartnerUpdating: false }));
        }
    };

    const deleteSuperpartner = async (data) => {
        setLoadingState(prev => ({ ...prev, isSuperpartnerDeleting: true }));
        try {
            const res = await SuperpartnerService.deleteSuperpartner(data);
            alertService.success("Superpartner eliminato con successo!", { autoClose: true });
            return res;
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isSuperpartnerDeleting: false }));
        }
    };

    return {
        loadingStateSuperpartner: loadingState,
        modalStateSuperpartner: modalState,
        setModalStateSuperpartner: setModalState,
        getAllSuperpartner, // La tua funzione originale
        getSuperpartnerByParams,
        createSuperpartner,
        updateSuperpartner,
        deleteSuperpartner,
    };
};

export default useSuperpartner;